module.exports = __webpack_public_path__ + "img/footer_separate.060089d0.svg";